import { Component, EventEmitter, inject, Input, OnInit, Output } from '@angular/core';
import { TrackService } from '../../service/track.service';
import { AiService } from '../../service/ai.service';
import { MatDialog } from '@angular/material/dialog';
import { SnackService } from '../../service/snack.service';
import { ReportService } from '../../service/report.service';

@Component({
  selector: 'app-marketanalyse',
  standalone: false,
  templateUrl: './marketanalyse.component.html',
  styleUrl: './marketanalyse.component.scss'
})
export class MarketanalyseComponent implements OnInit {
  // Injections
  trackservice = inject(TrackService);
  aiService = inject(AiService);
  dialog = inject(MatDialog);
  snack = inject(SnackService);
  report = inject(ReportService);

  // Inputs
  @Input() thisStepCount: number = 0;
  @Input() totalStepCount: number = 0;
  @Input() stepId: any;
  @Input() streamId: any;
  @Input() roundId: any;
  @Input() step: any;
  @Input() runClosingPrompt: boolean = false;
  @Input() initialReady: boolean = false;

  // Outputs
  @Output() nextStreamStepDisabledStatus: EventEmitter<boolean> = new EventEmitter(true);
  @Output() closingPromptReady: EventEmitter<{ "input": string, "type": string } | undefined> = new EventEmitter(undefined);


  ngOnInit(): void {
    this.nextStreamStepDisabledStatus.emit(false);
    setTimeout(() => {
      console.log("TCL: WebresearchComponent -> ",)
      this.closingPromptReady.emit({ input: "", type: "save-only" })
    }, 3000);
  }
}
